import React from "react";
import { AuthProvider, useAuth } from "./store/AuthContext";
import { BillingProvider, useBilling } from "./store/BillingContext";
import { Sidebar } from "./components/layout/Sidebar";
import { MobileNav } from "./components/layout/MobileNav";
import { Header } from "./components/layout/Header";
import { ToastContainer } from "./components/common/ToastContainer";
import { DocumentModal } from "./components/documents/DocumentModal";
import { DocumentPreviewModal } from "./components/documents/DocumentPreviewModal";
import { EntityModal } from "./components/entities/EntityModal";
import { DashboardView } from "./views/DashboardView";
import { InvoicesView } from "./views/InvoicesView";
import { QuotationsView } from "./views/QuotationsView";
import { ClientsView } from "./views/ClientsView";
import { ServicesView } from "./views/ServicesView";
import { ExpensesView } from "./views/ExpensesView";
import { AccountingView } from "./views/AccountingView";
import { SettingsView } from "./views/SettingsView";
import { LoginView } from "./views/LoginView";
import "./styles.css";

const MainContent: React.FC = () => {
  const { view } = useBilling();

  return (
    <>
      <div className="shell">
        <Sidebar />
        <MobileNav />

        <main>
          <Header />

          {view === "dashboard" && <DashboardView />}
          {view === "invoices" && <InvoicesView />}
          {view === "quotations" && <QuotationsView />}
          {view === "clients" && <ClientsView />}
          {view === "services" && <ServicesView />}
          {view === "expenses" && <ExpensesView />}
          {view === "accounting" && <AccountingView />}
          {view === "settings" && <SettingsView />}
        </main>
      </div>

      <DocumentModal />
      <DocumentPreviewModal />
      <EntityModal />
      <ToastContainer />
    </>
  );
};

const AuthGate: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="login-loading-screen">
        <div className="login-loading-content">
          <div className="login-brand-logo-wrap">
            <img
              src="/logo.png"
              alt="Revival Softech"
              className="login-loading-logo"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
          <div className="login-loading-spinner">
            <i className="fa-solid fa-circle-notch fa-spin" />
          </div>
          <p>Verifying secure session...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginView />;
  }

  return (
    <BillingProvider>
      <MainContent />
    </BillingProvider>
  );
};

export default function App() {
  return (
    <AuthProvider>
      <AuthGate />
    </AuthProvider>
  );
}
